import { ConfigStore } from '@/shared/model/store'
import { Badge, Button, Input, Switch } from '@/shared/ui'
import { getIpfsConfig } from '../lib/utils'

const JSON_CFG = {
	"API": {
		"HTTPHeaders": {
			"Access-Control-Allow-Credentials": [
				"true"
			],
			"Access-Control-Allow-Headers": [
				"Authorization",
				"Content-Type",
				"X-Requested-With"
			],
			"Access-Control-Allow-Methods": [
				"GET",
				"POST",
				"PUT",
				"OPTIONS"
			],
			"Access-Control-Allow-Origin": [
				"*"
			],
			"Access-Control-Expose-Headers": [
				"Location",
				"Content-Disposition"
			]
		}
	},
}

const IpfsSettings = () => {
	const { localGateway, localGatewayPort, setLocalGateway } = ConfigStore()

	const getConfig = async () => {
		await getIpfsConfig()
	}

	return (
		<div>
			<div className='flex items-center justify-between border-b-2 pb-2 font-bold'>
				<div className='flex items-end gap-4'>
					<span>Local IPFS settings</span>
				</div>
				<span>
					{localGateway.on_air && <Badge variant={'success'}>Connected</Badge>}
					{localGateway.enable && !localGateway.on_air && (
						<Badge variant={'destructive'}>{`Disconnected: ${localGateway.error}`}</Badge>
					)}
					{!localGateway.enable && <Badge variant={'secondary'}>Disabled</Badge>}
				</span>
			</div>
			<div className='mt-2 flex items-center justify-between'>
				<div className='flex items-center gap-4'>
					<span>Enable local IPFS</span>
					<div className='flex items-center gap-1'></div>
				</div>
				<Switch
					checked={localGateway?.enable}
					onCheckedChange={state => setLocalGateway({ ...localGateway, enable: state })}
				/>
			</div>
			<div>
				<div className='mt-3 flex items-center justify-between'>
					<span className='text-[12px] text-[grey]'>Local IPFS URL</span>
					<div className='flex w-[50%] items-center justify-end gap-2'>
						<Input
							value={localGateway?.url}
							disabled={!localGateway.enable}
							onChange={e => setLocalGateway({ ...localGateway, url: e.target.value })}
							placeholder='http://localhost:5001'
							className='w-[50%] rounded-md border-[1px] border-gray-400 p-2'
						/>
						<Button onClick={getConfig} disabled={!localGateway.enable}>
							Check connect
						</Button>
					</div>
				</div>
			</div>
			<div>
				<div className='mt-3 flex items-center justify-between'>
					<span className='text-[12px] text-[grey]'>Local IPFS port</span>
					<span>{localGatewayPort || 'unknown'}</span>
				</div>
			</div>
			{/* <div>
				<div className='mt-3 flex items-center justify-between'>
					<span className='text-[12px] text-[grey]'>Local IPFS link</span>
					<span>{localGateway?.ipfs_link || 'unknown'}</span>
				</div>
			</div> */}
			<div className='mt-3 text-[12px] text-[grey]'>
				<p>
					Если при включенной локальной IPFS, что то не работет, то попробуйте вставить такие настройки
				</p>
				<pre className=' p-4 rounded-md bg-gray-200'>
					<code>{JSON.stringify(JSON_CFG, null, 2)}</code>
				</pre>
			</div>
		</div>
	)
}

export default IpfsSettings
